<template>
  <div class="limit-settings-preview">
    <b-table v-if="settings" :items="rows" :fields="fields" small striped responsive>
      <template #cell(value)="{ item }">
        <span v-if="item.color" class="chip-swatch mr-2" :style="{ backgroundColor: item.color }" aria-hidden="true"></span>
        {{ item.value }}
      </template>
    </b-table>
    <p v-else class="text-muted mb-0">{{ emptyText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    settings: Object,
    emptyText: { type: String, default: 'No settings' }
  },
  data() {
    return { fields: [{ key: 'field', label: 'Setting' }, { key: 'value', label: 'Value' }] }
  },
  computed: {
    rows() {
      const rows = []
      const visit = (value, path) => {
        if (value !== null && typeof value === 'object') {
          Object.keys(value).forEach(key => visit(value[key], path ? `${path}.${key}` : key))
        } else {
          rows.push({
            field: path,
            value: value === null ? '-' : String(value),
            color: /\.color$/.test(path) && /^#[0-9a-f]{3,8}$/i.test(value) ? value : null
          })
        }
      }
      visit(this.settings, '')
      return rows
    }
  }
}
</script>

<style scoped>
.limit-settings-preview { overflow-wrap: anywhere; }
.chip-swatch { display: inline-block; width: 16px; height: 16px; border: 1px solid #6c757d; vertical-align: middle; }
</style>
